<template>
  <div class="notice-wapper">
    <van-pull-refresh
      v-model="refreshing"
      @refresh="getNoticeList"
      style="min-height: 100vh"
    >
      <van-cell-group>
        <div class="cell" v-for="(item, index) in noticeList" :key="index">
          <div class="cell-left">
            <!-- <img class="cell-left-img" :src="imgBaseUrl+item.picAddress+item.picId+'.png'"/> -->
            <img class="cell-left-img" :src="item.img" />
          </div>
          <div class="cell-right">
            <div class="van-hairline--bottom">
              <van-cell
                center
                :title="item.picName"
                :label="item.outline ? item.outline : '暂无消息'"
                is-link
                title-style="font-size:16px"
                label-class="label-class"
                @click="toNoticeList(item)"
              >
                <template #default>
                  <span class="noticecount" v-if="item.count > 99">99+</span>
                  <span class="noticecount" v-else-if="item.count > 0">{{
                    item.count
                  }}</span>
                </template>
              </van-cell>
            </div>
          </div>
        </div>
      </van-cell-group>
    </van-pull-refresh>
  </div>
</template>

<script>
import checkAJB from '@/utils/checkAlipayJSBridge';
import Vue from 'vue';
import { Cell, CellGroup, Toast } from 'vant';
Vue.use(Cell);
Vue.use(CellGroup);
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      noticeList: [],
      /*         {
          picName:"办事进度",
          count:"0",
          img:require("@/assets/img/notice/0004.png"),
          picAddress:"/govmm/attfiles/",
          picId:"693162676087128070",
        },
        {
          picName:"动账通知",
          count:"0",
          img:require("@/assets/img/notice/0005.png"),
          picAddress:"/govmm/attfiles/",
          picId:"693161817093660677",
        },
        {
          picName:"投诉咨询",
          count:"0",
          img:require("@/assets/img/notice/0003.png"),
          picAddress:"/govmm/attfiles/",
          picId:"693162676087128074",
        },{
          picName:"系统公告",
          count:"0",
          img:require("@/assets/img/notice/0002.png"),
          picAddress:"/govmm/attfiles/",
          picId:"693162676087128077",
        },{
          picName:"政策推送",
          count:"0",
          img:require("@/assets/img/notice/0001.png"),
          picAddress:"/govmm/attfiles/",
          picId:"693161817093660683",
        }
      ], */
      imgBaseUrl: '/sga',
      refreshing: false,
    };
  },
  computed: {
    ...mapGetters(['sessionId', 'userInfo', 'userId']),
  },
  async created() {
    await this.ensureLogin();
    this.getNoticeList();
  },
  filters: {},
  methods: {
    async ensureLogin() {
      let userRes = await this.$store.dispatch('user/getUserInfo', {
        loginByphone: true,
      });
      console.log('userRes==', userRes);
      console.log('进页面了');
      if (!userRes.sgasession) {
        await checkAJB.userLogin({ loginByphone: true });
        await this.$store.dispatch('user/getUserInfo');
      }
      this.sessionInfo = JSON.parse(this.userInfo);
      this.loginFlag = this.sessionInfo.loginFlag;
      this.identLevel = this.sessionInfo.identLevel;
      // if (this.identLevel > "1" && this.loginFlag=="1") {//
      //   await checkAJB.userVerify()
      //   userRes = await this.$store.dispatch("user/getUserInfo");
      // }else if(this.identLevel == "1"){
      //   await checkAJB.userAuth()
      //   userRes = await this.$store.dispatch("user/getUserInfo");
      // }
    },
    toNoticeList(item) {
      /* this.$router.push({
        name: 'noticeList',
        query: item
      }); */
      this.$router.push('/noticeList?segmentId=' + item.segmentId);
    },
    async getNoticeList() {
      //checkAJB.showLoading("加载中...")
      if (this.refreshing) {
        this.refreshing = false;
      }
      Toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      try {
        let res = await checkAJB.httpRequest({
          url: '/sga/user/msgCenterList',
          type: 'post',
          headers: {
            'Content-Type': 'application/json',
            sgasession: this.sessionId,
          },
          data: {},
        });
        //checkAJB.hideLoading()
        Toast.clear();
        console.log('获取消息分类别表', res);
        if (res.respCode == '00000000') {
          this.noticeList = res.respData;
          this.addImgUrl();
        } else if (
          res.respCode == 'SGAUU001' ||
          res.respCode == 'SGAU0002' ||
          res.respCode == 'SGAU0003'
        ) {
          await checkAJB.userLogin();
          await this.ensureLogin();
          this.getReferer();
        } else {
          checkAJB.toast(res.respMsg);
        }
      } catch (e) {
        //Toast.clear();
        Toast.fail('网络不佳\n请稍后重试');
        console.log('error', e);
      }
    },
    addImgUrl() {
      for (let i = 0; i < this.noticeList.length; i++) {
        if (this.noticeList[i].picName == '办事进度') {
          this.noticeList[i].img = require('@/assets/img/notice/0004.png');
        }
        if (this.noticeList[i].picName == '动账通知') {
          this.noticeList[i].img = require('@/assets/img/notice/0005.png');
        }
        if (this.noticeList[i].picName == '投诉咨询') {
          this.noticeList[i].img = require('@/assets/img/notice/0003.png');
        }
        if (this.noticeList[i].picName == '系统公告') {
          this.noticeList[i].img = require('@/assets/img/notice/0002.png');
        }
        if (this.noticeList[i].picName == '政策推送') {
          this.noticeList[i].img = require('@/assets/img/notice/0001.png');
        }
        if (this.noticeList[i].picName == '气象预警') {
          this.noticeList[i].img = require('@/assets/img/notice/0006.png');
        }
        if (this.noticeList[i].picName == '社区通知') {
          this.noticeList[i].img = require('@/assets/img/notice/0007.png');
        }
        if (this.noticeList[i].picName == '党建平台') {
          this.noticeList[i].img = require('@/assets/img/notice/0008.png');
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.notice-wapper {
  padding-top: 6px;
  .cell {
    display: flex;
    padding: 0px 10px;
    .cell-left {
      padding: 15px 0 10px 0;
      .cell-left-img {
        width: 45px;
        height: 45px;
      }
    }
    .cell-right {
      flex: 1;
      padding-left: 10px;
      .label-class {
        width: 100%;
        font-size: 13px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
      }
      /deep/ .van-cell {
        padding: 15px 0px;
        .van-cell__title {
          flex: 32;
        }
        .van-cell__value {
          flex: 5;
          text-align: center;
          position: absolute;
          right: 15px;
          .noticecount {
            background-color: #ee0707;
            font-size: 12px;
            color: #ffffff;
            padding: 0px 5px;
            height: 14px;
            line-height: 14px;
            text-align: center;
            vertical-align: middle;
            border-radius: 14px;
          }
        }
        .van-cell__label {
          height: 16px;
          width: 7rem;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
